<!-- Loading and error -->
<app-loading-status *ngIf="loaderService.isLoading | async; else notLoading"></app-loading-status>
<app-alert-status *ngIf="loadingError" [loadingError]="loadingError"></app-alert-status>

<!-- Project List (no current project) -->
<ng-template #notLoading>
    <ng-container>
        <div class="container-fluid">
            <div class="row justify-content-center">
                <div class="col-md-11 col-12">

                    <div class="row mt-5 mb-3">
                        <div class="col-md-7 col-12" *ngIf="layout">
                            <app-area-heading [heading]="layout.heading" [subheading]="layout.subheading" [backRoute]="layout.backRoute"></app-area-heading>
                        </div>
                        <div class="col-md-5 col-12 d-flex">
                            <div class="ml-auto">
                                <app-year-select (emitCurrentYear)="yearChange($event)"></app-year-select>
                            </div>
                        </div>
                    </div>
                    <app-dynamic-table
                        [data]="rolesList" 
                        [columns]="rolesTableColumns"
                        [tableTitle]="'rolesList'"
                        [primaryKey]="'user_role_id'"
                        [onRowClick]="onTableRowClick"
                    >
                    </app-dynamic-table>

                </div>
            </div>
        </div>
    </ng-container>
</ng-template>